import { render, staticRenderFns } from "./ShuttleTable.vue?vue&type=template&id=1df0029c&scoped=true&"
import script from "./ShuttleTable.vue?vue&type=script&lang=js&"
export * from "./ShuttleTable.vue?vue&type=script&lang=js&"
import style0 from "./ShuttleTable.vue?vue&type=style&index=0&id=1df0029c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df0029c",
  null
  
)

export default component.exports